// WS-протокол живого канала. SPEC shared-contracts §4.7 (+ transcript.failed, правка L).
// Оба направления — дискриминированные объединения по полю `t`.
export const WS_PROTOCOL_VERSION = 1;
//# sourceMappingURL=ws.js.map